export function getOferteConfirm ({ state, commit }, { search, datefrom, dateto, page = 1}) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/oferteconfirm', { params: { search, datefrom, dateto, page } })
      .then((response) => {
        if (response.data.oferte) {
          commit('setOferte', response.data)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getOfertaConfirm ({ state, commit }, ofertaId) {
  return new Promise((resolve, reject) => {
    if (ofertaId) {
      axiosInstance.get('/v1/oferteconfirm/' + ofertaId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa oferta id'))
    }
  })
}

export function geteOriginalOferta ({ state, commit }, ofertaId) {
  return new Promise((resolve, reject) => {
    if (ofertaId) {
      axiosInstance.get('/v1/oferte/o/oferta/' + ofertaId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa oferta eOriginal id'))
    }
  })
}

export function geteOriginalOfertaPDF ({ state, commit }, url) {
  return new Promise((resolve, reject) => {
    if (url) {
      axiosInstance.get(url)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa URL download pdf'))
    }
  })
}

export function getEditOfertaConfirm ({ state, commit }, ofertaId) {
  return new Promise((resolve, reject) => {
    if (ofertaId) {
      axiosInstance.get('/v1/oferteconfirm/' + ofertaId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa oferta id'))
    }
  })
}

/* eslint-disable-next-line */
export function editOfertaConfirm ({ state, commit }, { id, name, permission }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/oferteconfirm/' + id, { name, permission })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa oferta id'))
    }
  })
}

export function deleteOfertaConfirm ({ state, commit }, ofertaId) {
  return new Promise((resolve, reject) => {
    if (ofertaId) {
      axiosInstance.delete('/v1/oferteconfirm/' + ofertaId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa oferta id'))
    }
  })
}
